import { DbObjectBase } from './db-object-base';
import { ICollectionReference } from '../database-cast/IDatabase';
import { DbListBase } from './db-list-base';
import { System } from '../../_shared/models/Customer';

export class DbSystems extends DbListBase<System> {

    constructor(collection: ICollectionReference) {
      super(collection);
  
    }
  
    public getSystem(id: string): DbSystem {
      return new DbSystem(id, this._collection);
    }
  }
  
  
  export class DbSystem extends DbObjectBase<System> {
  
    constructor(id: string, collection: ICollectionReference) {
  
      super(id, collection);
  
    }
  
  }